import { array, InferType, mixed, object, ObjectSchema } from "yup";
import { SelectFinishError } from "../constants.ts";
import { models } from "types/api/viewModels.ts";

export interface SelectCustomColorModalSchema {
	finishes?: models["FinishViewModel"][] | null;
}

export const customColorModalSchema: ObjectSchema<SelectCustomColorModalSchema> = object({
	finishes: array()
		.nullable()
		.when("$hasFinishes", {
			is: true,
			then: (schema) =>
				schema.of(mixed<models["FinishViewModel"]>().required(SelectFinishError)).required(SelectFinishError),
			otherwise: (schema) => schema.notRequired().nullable() // no .of() means no item validation!
		})
});

export type FinishFields = InferType<typeof customColorModalSchema>;
